<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select
        v-model="listQuery.college_id"
        placeholder="请选择院系"
        style="width: 150px; margin-left: 10px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in schools"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-input
        v-model="listQuery.name"
        placeholder="请输入专业名称"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.is_e_sports"
        placeholder="请选择专业类型"
        clearable
        class="filter-item"
      >
        <el-option label="电竞专业" :value="1" />
        <el-option label="普通专业" :value="0" />
      </el-select>
      <el-button class="filter-item" type="primary" @click="getList">
        查找
      </el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      @cell-click="cellClick"
    >
      <el-table-column label="序号" width="95" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="学校" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.college.school.name }}
        </template>
      </el-table-column>
      <el-table-column label="院系" min-width="110" align="center">
        <template slot-scope="scope"> {{ scope.row.college.name }} </template>
      </el-table-column>
      <el-table-column label="专业" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.name }} </template>
      </el-table-column>
      <el-table-column label="学年制度" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.study_year_num }} </template>
      </el-table-column>
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.is_on">正常</el-tag>
          <el-tag type="danger" v-else>已下架</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="是否电竞专业" min-width="110" align="center">
        <template slot-scope="scope">
          <!-- <el-input
            ref="gain"
            size="mini"
            v-if="scope.row.isEdit"
            @blur="blurClick(scope)"
            :autofocus="true"
          ></el-input> -->
          <el-switch
            v-model="scope.row.is_e_sports"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            :inactive-value="0"
            @change="blurClick(scope)"
          >
          </el-switch>
          <!-- <template v-else>
            <el-tag type="success" v-if="scope.row.is_e_sports">是</el-tag>
            <el-tag type="danger" v-else>否</el-tag>
          </template> -->
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  data() {
    return {
      list: [],
      total: null,
      listLoading: false,
      school_years: [],
      colleges: [],
      grades: [],
      majors: [],
      school_year: null,
      listQuery: {
        page: 1,
        limit: 10,
        college_id: "",
        name: "",
        is_e_sports: "",
        school_id: "",
      },
      dialogFormVisible: false,
      dialogStatus: "",
      btnLoading: false,
      grade_id: "",
      schools: [],
      id: null,
    };
  },
  watch: {
    school_year(newV, oldV) {
      console.log(newV, oldV, "=========");
      this.form.school_year = newV;
    },
    grade_id(newV, oldV) {
      console.log(newV, oldV, "=========");
      this.form.grade_id = newV;
    },
  },
  created() {
    this.listQuery.school_id = this.$route.query.id;
    this.getList();
    this.getSchoolList();
  },
  methods: {
    cellClick(row, column, event) {
      if (column.label === "是否电竞专业") {
        this.$set(row, "isEdit", true);
      }
      this.$forceUpdate();
    },
    blurClick({ row, column }) {
      this.$set(row, "isEdit", false);
      // console.log(row, "======");
      // if (row.is_e_sports) {
      //   this.$set(row, "is_e_sports", 0);
      // } else {
      //   this.$set(row, "is_e_sports", 1);
      // }
      // this.$forceUpdate()//强制更新
      request({
        url: "/api/backend/school/majorIsESportsStore",
        method: "post",
        data: { id: row.id, is_e_sports: row.is_e_sports },
      }).then(() => {
        this.getList();
      });
    },
    //  获取学校列表
    getSchoolList() {
      request({
        url: "/api/backend/school/collegeList",
        method: "get",
        params: { limit: 9999999, school_id: this.listQuery.school_id },
      }).then((response) => {
        this.schools = response.data.data;
      });
    },
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/school/majorList",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data;
        this.list.forEach((item) => {
          item.isEdit = false;
        });
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    resetForm() {
      this.form = {
        id: "",
        name: "",
      };
    },
    handleCreate() {
      this.resetForm();
      this.grade_id = "";
      this.dialogStatus = "create";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    handleUpdate(row) {
      console.log(row);
      this.resetForm();
      this.form = Object.assign({}, row);
      this.school_year = row.grade.school_year;
      this.form.school_year = row.grade.school_year;
      this.grade_id = row.grade_id;
      // if (this.form.school_year) {
      this.getGradeList(1);
      // }
      this.getMajorList(1);
      // console.log();
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    saveData() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/school/classStore",
            method: "post",
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false;
              this.dialogFormVisible = false;
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.getList();
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        }
      });
    },
    //上下架
    handleStatus(val, text) {
      this.$confirm("此操作将" + text + "该院系, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/school/classUpDown",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
    // 获取省
    getProvince() {
      return request({
        url: "/api/common/area/index",
        method: "get",
      }).then((res) => {
        this.provinces = res.data;
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
